import axios from "axios";

/**
 * Cloudflare routes /api/* to the backend on whatever host is serving the app, so once the
 * visitor is on a different origin than the configured one (www vs apex, or a custom domain)
 * we talk to the backend same-origin — that keeps CORS and the httpOnly auth cookies working.
 */
function resolveApiBase() {
  const configured = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return `${configured}/api`;
  try {
    if (new URL(configured).origin !== window.location.origin) return "/api";
  } catch {
    return "/api";
  }
  return `${configured}/api`;
}

export const API_BASE = resolveApiBase();

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (typeof d?.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  return String(detail);
}
